<template>
  <span @dblclick="edit">
    <span :contenteditable="editing" :ref="ref" @blur="cancel" @keydown.enter.prevent="submit">
      {{ content }}
    </span>
  </span>
</template>

<script>
export default {
  created () {
    const model = this.$_.get(this.$store.state, `core.${this.service}.entity`)

    this.id = model._id
    this.content = this.$_.get(model, this.attribute)
    this.original = this.$_.clone(this.content)
    this.ref = `editable-${this.$id.gen()}`
  },

  data: () => ({
    content: '',
    editing: false,
    id: null,
    ref: null
  }),

  name: 'EditableContent',

  props: {
    attribute: String,
    service: String
  },

  methods: {
    cancel () {
      this.$refs[this.ref].innerText = this.original

      this.editing = false
      this.content = this.original
    },

    edit () {
      this.editing = true

      setTimeout(() => {
        this.$refs[this.ref].focus()
      }, 100)
    },

    async submit ($event) {
      const payload = { _id: this.id }
      const content = $event.target.textContent

      if (this.$_.trim(content) === '') {
        return this.cancel()
      }

      payload[this.attribute] = content

      await this.$store.dispatch(`core/${this.service}/save`, payload)

      this.content = content
      this.editing = false
      this.original = content
    }
  }
}
</script>

<style>
.editable-icon {
  font-size: 60%
}
</style>
